import { useContext } from 'react'

import { ThemeEditorContext } from '../providers/ThemeEditorProvider'

export const useThemeEditorContext = () => {
  const themeEditorContext = useContext(ThemeEditorContext)

  if (themeEditorContext === undefined) {
    throw new Error('themeEditorContext must be used within a ThemeEditorProvider')
  }

  return themeEditorContext
}
